<template>
  <v-dialog
    :value="enableDialog"
    persistent
    width="900"
    @keydown.esc="closeButtonClickEvent"
    @close="closeButtonClickEvent"
  >
    <validation-observer
      ref="observer"
    >
      <v-card flat>
        <v-toolbar flat color="primary" dark>
          <v-toolbar-title>
            紙マニフェスト返却日（個別登録）
          </v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text
          v-if="forms"
          style="max-height: 60vh;overflow-y: scroll"
        >
          <v-card
            v-for="(form, index) in forms"
            :key="form.id"
            flat
          >
            <v-card-text>
              <manifest-detail :manifest="form" :caller-type="'paper_register'" />
            </v-card-text>
            <v-card-text>
              <paper-register-form
                :manifest="form"
                :head="index < 1"
                :solo="forms.length === 1"
                @copyButtonCallback="copyTarget"
              />
            </v-card-text>
            <v-divider />
          </v-card>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            @click="closeButtonClickEvent"
          >
            閉じる
          </v-btn>
          <v-btn
            :disabled="forms === null"
            class="primary"
            @click="registerButtonClickEvent"
          >
            登録
          </v-btn>
        </v-card-actions>
      </v-card>
    </validation-observer>
  </v-dialog>
</template>
<script>

import manifestDetail from '../../../dialogs/contents/_ManifestDetail.vue'
import paperRegisterForm from './forms/_PaperRegisterForm.vue'
import { mapActions } from 'vuex'

export default {
  name: "PaperRegisterDialog",
  components: {
    manifestDetail,
    paperRegisterForm,
  },
  mixins: [],
  props: {
    enableDialog: {
      type: Boolean,
      default: () => false,
    },
    manifestIds: {
      type: Array,
      default: () => []
    },
    sortType: {
      type: String,
      default: () => null,
    },
  },
  data() {
    return {
      forms: null,
    }
  },
  computed: {},
  watch: {
    enableDialog (newValue) {
      this.forms = null
      if (newValue) {
        this.setVariable()
      }
    },
  },
  created() {
  },
  methods: {
    ...mapActions('DriverManifestPaperRegister', {
      fetchPaperManifestReturnVotes: 'show',
      registerPaperManifestReturnVotes: 'update',
    }),
    /**
     * 閉じるボタン クリックイベント
     */
    closeButtonClickEvent () {
      this.$emit('cancelCallback')
    },
    /**
     * 登録ボタン クリックイベント
     */
    registerButtonClickEvent () {
      this.$refs.observer.validate().then((result) => {
        if (result) {
          this.register()
        }
      })
    },
    /**
     * 初期表示
     */
    setVariable () {
      const manifest_ids = this.manifestIds.join(',')
      this.fetchPaperManifestReturnVotes({params: { manifest_ids: manifest_ids, sort_type: this.sortType }}).then((content) => {
        this.forms = content.paper_manifest_return_votes
      })
    },
    /**
     * 登録処理
     */
    register () {
      let data = []
      for (const form of this.forms) {
        data.push({
          manifest_id: form.manifest_id,
          a_return_date: form.a_return_date,
          a_return_target: form.a_return_target,
          b2_return_date: form.b2_return_date,
          b2_return_target: form.b2_return_target,
          b4_return_date: form.b4_return_date,
          b4_return_target: form.b4_return_target,
          b6_return_date: form.b6_return_date,
          b6_return_target: form.b6_return_target,
          d_return_date: form.d_return_date,
          d_return_target: form.d_return_target,
          e_return_date: form.e_return_date,
          e_return_target: form.e_return_target,
          b1_return_date: form.b1_return_date,
          b1_return_target: form.b1_return_target,
          c1_return_date: form.c1_return_date,
          c1_return_target: form.c1_return_target,
          c2_return_date: form.c2_return_date,
          c2_return_target: form.c2_return_target,
        })
      }
      this.registerPaperManifestReturnVotes({ params: {manifests: data} }).then(() => {
        this.$emit('registerEvent')
      })
    },
    copyTarget (column, value) {
      for (const form of this.forms) {
        if (column === 'a_return_date') {
          form.a_return_date = value
        } else if (column === 'a_return_target') {
          form.a_return_target = value
        } else if (column === 'b2_return_date') {
          form.b2_return_date = value
        } else if (column === 'b2_return_target') {
          form.b2_return_target = value
        } else if (column === 'b4_return_date') {
          form.b4_return_date = value
        } else if (column === 'b4_return_target') {
          form.b4_return_target = value
        } else if (column === 'b6_return_date') {
          form.b6_return_date = value
        } else if (column === 'b6_return_target') {
          form.b6_return_target = value
        } else if (column === 'd_return_date') {
          form.d_return_date = value
        } else if (column === 'd_return_target') {
          form.d_return_target = value
        } else if (column === 'e_return_date') {
          form.e_return_date = value
        } else if (column === 'e_return_target') {
          form.e_return_target = value
        } else if (column === 'b1_return_date') {
          form.b1_return_date = value
        } else if (column === 'b1_return_target') {
          form.b1_return_target = value
        } else if (column === 'c1_return_date') {
          form.c1_return_date = value
        } else if (column === 'c1_return_target') {
          form.c1_return_target = value
        } else if (column === 'c2_return_date') {
          form.c2_return_date = value
        } else if (column === 'c2_return_target') {
          form.c2_return_target = value
        }
      }
    }
  }
}
</script>
